module.exports = __webpack_public_path__ + "img/mr_head_ic1.ae1d1dbe.jpg";